import React from "react";
import { Box } from "@mui/material";

const WallArtPage = () => {
  return (
    <Box
      sx={{
        padding: 10,
      }}
    >
      {"WIP: Shoulder"}
    </Box>
  );
};

export default WallArtPage;
